import styled from 'styled-components'
import theme from 'theme_'

export const StyledDescription = styled.div`
  color: ${theme.colors.beachGrey};
  margin-bottom: ${theme.spacing.lg};
`
